import React from "react";
import DocumentMeta from "./DocumentMeta";
import { ROUTE_META } from "./routeMeta";

const storeLinks = [
  {
    label: "Get it on Google Play",
    href: "https://play.google.com/store/apps/details?id=com.appazzola.catchaos&pcampaignid=web_share",
    img: "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg",
    alt: "Get it on Google Play",
  },
  {
    label: "Download on the App Store",
    href: "https://apps.apple.com/us/app/rascal-cat/id6761418594",
    img: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg",
    alt: "Download on the App Store",
  },
];

const legalLinks = [
  {
    label: "Privacy Policy",
    href: "/privacy/rascal-cat",
  },
  {
    label: "Terms and Conditions",
    href: "/terms/rascal-cat",
  },
];

const RascalCatPage = () => (
  <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(45,212,191,0.24),_transparent_34%),linear-gradient(135deg,_#fff7ed,_#ffffff_48%,_#ecfeff)] px-6 py-12 text-gray-900">
    <DocumentMeta
      title={ROUTE_META.rascalCatGame.title}
      description={ROUTE_META.rascalCatGame.description}
      robots={ROUTE_META.rascalCatGame.robots}
    />

    <div className="mx-auto max-w-5xl">
      <a
        href="/"
        className="inline-flex items-center gap-2 rounded-full border border-teal-100 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition hover:border-teal-300 hover:text-teal-700"
      >
        <span aria-hidden="true">&larr;</span>
        Back to home
      </a>

      <section className="mt-8 overflow-hidden rounded-3xl border border-white bg-white/90 shadow-[0_30px_120px_rgba(15,23,42,0.12)] ring-1 ring-teal-100/70">
        <div className="grid gap-10 p-8 md:grid-cols-[1fr_18rem] md:p-12">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-teal-500">
              Mobile Game
            </p>
            <h1 className="mt-4 text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl">
              Rascal Cat
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-gray-600">
              Rascal Cat is a playful mobile game about quick sessions,
              cheerful progression, and cat-led chaos. It is available now on
              Google Play and the App Store.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {["Quick sessions", "Cloud save", "Leaderboards"].map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-teal-200 bg-teal-50 px-4 py-2 text-sm font-semibold text-teal-700"
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
              {storeLinks.map((link) => (
                link.disabled ? (
                  <span
                    key={link.label}
                    className="inline-flex h-14 cursor-not-allowed items-center justify-center rounded-2xl bg-gray-200 px-6 py-3 text-sm font-bold text-gray-500 shadow-sm"
                  >
                    {link.label}
                  </span>
                ) : (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-14 items-center justify-center rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl"
                  >
                    <img src={link.img} alt={link.alt} className="h-10" />
                  </a>
                )
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              {legalLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm font-semibold text-teal-700 underline decoration-teal-300 underline-offset-4 transition hover:text-teal-900"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="rounded-3xl border border-teal-100 bg-gradient-to-br from-teal-50 to-orange-50 p-6 text-center shadow-[0_20px_80px_rgba(13,148,136,0.16)]">
            <img
              src="/rascal-cat-app-icon.png"
              alt="Rascal Cat app icon"
              className="mx-auto h-40 w-40 rounded-[2rem] object-cover shadow-xl ring-1 ring-white"
            />
            <p className="mt-6 text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
              Available Now
            </p>
            <p className="mt-2 text-sm leading-6 text-gray-600">
              Google Play and App Store
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default RascalCatPage;
